var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3785_11565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.8651 59.6516C89.8765 60.6912 79.5558 64.9336 77.3326 66.098C75.1094 67.2624 73.9187 67.2293 72.1799 66.3987C70.4411 65.568 59.4958 61.1193 57.5123 60.1714C56.5128 59.7026 56.0029 59.3026 56.0029 58.928V55.1545C56.0029 55.1545 70.3009 52.0536 72.6083 51.2178C74.9156 50.3821 75.7136 50.3617 77.6743 51.0803C79.6349 51.7988 91.3884 53.9187 93.3286 54.6219V58.342C93.3286 58.7293 92.8824 59.1064 91.8651 59.6491V59.6516Z",
    fill: "#A32422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8648 55.8959C89.8761 56.9303 79.5555 61.1727 77.3322 62.3168C75.109 63.4608 73.9184 63.4506 72.1796 62.6225C70.4407 61.7944 59.4955 57.3457 57.5119 56.4055C55.5283 55.4652 55.4901 54.8079 57.4354 54.0486C59.3807 53.2893 70.3005 49.0163 72.6079 48.1755C74.9152 47.3347 75.7133 47.3168 77.6739 48.0379C79.6345 48.759 89.9118 52.8383 91.8418 53.5492C93.7718 54.2601 93.8611 54.8435 91.8648 55.8755V55.8959Z",
    fill: "#DC382C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8651 53.5059C89.8765 54.5429 79.5558 58.7827 77.3326 59.9268C75.1094 61.0708 73.9289 61.0606 72.1901 60.2274C70.4513 59.3943 59.4958 54.971 57.5123 54.0257C56.5128 53.5518 56.0029 53.1543 56.0029 52.7772V49.0164C56.0029 49.0164 70.3009 45.9053 72.6083 45.0695C74.9156 44.2338 75.7136 44.2109 77.6743 44.9396C79.6349 45.6683 91.3884 47.7679 93.3286 48.4762V52.1962C93.3286 52.5835 92.8824 52.9708 91.8651 53.5059Z",
    fill: "#A32422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8648 49.7323C89.8761 50.7719 79.5555 55.0117 77.3322 56.1557C75.109 57.2998 73.9184 57.2921 72.1796 56.4615C70.4408 55.6309 59.4955 51.1999 57.5119 50.2521C55.5283 49.3042 55.4926 48.6596 57.4354 47.9003C59.3782 47.141 70.3005 42.8579 72.6079 42.04C74.9152 41.2221 75.7133 41.1711 77.6739 41.882C79.6345 42.5929 89.9118 46.7079 91.8418 47.3984C93.7718 48.0889 93.8611 48.6953 91.8648 49.7247V49.7323Z",
    fill: "#DC382C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8651 47.1284C89.8765 48.168 79.5558 52.4104 77.3326 53.5519C75.1094 54.6934 73.9289 54.6857 72.1901 53.8576C70.4513 53.0295 59.4958 48.5935 57.5123 47.6482C56.5128 47.1794 56.0029 46.7794 56.0029 46.4023V42.6287C56.0029 42.6287 70.3009 39.5278 72.6083 38.6946C74.9156 37.8614 75.7136 37.836 77.6742 38.5545C79.6349 39.273 91.3833 41.3929 93.3235 42.1013V45.8213C93.3286 46.2137 92.8824 46.5959 91.8651 47.1284Z",
    fill: "#A32422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8648 43.3588C89.8761 44.378 79.5555 48.6459 77.3322 49.7797C75.109 50.9136 73.9184 50.911 72.1796 50.0855C70.4407 49.2599 59.4955 44.8188 57.5119 43.8761C55.5283 42.9333 55.4901 42.2785 57.4354 41.5192C59.3807 40.7599 70.3005 36.4793 72.6079 35.6487C74.9152 34.818 75.7133 34.7925 77.6739 35.5111C79.6345 36.2296 89.9118 40.314 91.8418 41.0223C93.7718 41.7307 93.8611 42.3193 91.8648 43.3512V43.3588Z",
    fill: "#DC382C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.252 38.0016L77.7149 37.1939L77.0469 38.7889L79.5531 39.7266L76.3228 40.0629L75.5962 41.8057L74.4285 39.8616L70.6934 39.5253L73.4826 38.5214L72.6438 36.9773L75.252 38.0016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.407 48.1757L69.3696 45.671L78.0178 44.3435L75.407 48.1757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.037 40.6946C69.5866 40.6946 71.6594 41.4972 71.6594 42.4782C71.6594 43.4591 69.5815 44.2617 67.037 44.2617C64.4926 44.2617 62.4121 43.4591 62.4121 42.4782C62.4121 41.4972 64.4849 40.6946 67.037 40.6946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3799 40.2029L88.4969 42.2234L83.385 44.244L83.3799 40.2029Z",
    fill: "#741113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.38 40.2029L83.3851 44.244L82.8293 44.4605L77.7148 42.44L83.38 40.2029Z",
    fill: "#AC2724"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3785_11565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 33,
    fill: "white",
    transform: "translate(56 34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedis);
export default __webpack_public_path__ + "static/media/redis.fa8d0cc7691e4c28cae8b996217c1122.svg";
export { ForwardRef as ReactComponent };